import { Game } from "onearm";
import { GameConfig } from "./configs/GameConfig";
import "onearm/components/addComponents.js";
import { GSDevTools } from "gsap/GSDevTools";
import gsap from "gsap";


Game.start(GameConfig);



